import { computed } from 'vue';

export default function useBotServiceURL() {
  const botServiceUrls = {
    'app.c7o.ai': 'bot-service.enegel.ai',
    'stage.c7o.ai': 'bots-stage.enegel.ai',
    'app.enegel.ai': 'bot-service.enegel.ai',
    'stage.enegel.ai': 'bots-stage.enegel.ai',
  };

  const botServiceURL = computed(() => {
    const host = window.location.host;
    if (host in botServiceUrls) {
      return botServiceUrls[host];
    }
    return 'localhost:3070';
  });

  return { botServiceURL };
}